import { computed, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, EMPTY, interval, Observable, startWith, switchMap } from 'rxjs';
import { FETCH_INTERVAL_MS } from '../constants/api';
import { SessionStore } from '../stores/session.store';

/** Starts polling when authenticated; stops on logout. Call from a service constructor. */
export function startAuthenticatedPolling(fetch: () => Observable<unknown>): void {
  const destroyRef = inject(DestroyRef);
  const sessionStore = inject(SessionStore);
  const authenticated = computed(() => sessionStore.currentSession() != null);

  toObservable(authenticated)
    .pipe(
      distinctUntilChanged(),
      switchMap((isAuthenticated) => {
        if (!isAuthenticated) return EMPTY;

        return interval(FETCH_INTERVAL_MS).pipe(
          startWith(0),
          switchMap(() => fetch()),
        );
      }),
      takeUntilDestroyed(destroyRef),
    )
    .subscribe();
}
